module.exports = __webpack_public_path__ + "img/bathymetry_bw_composite_4k.6f50d964.jpg";